import get from 'lodash/get';
import * as companyActions from '../../action_creators/mic/company_action_creators';
import CompanyModel from '../../../models/mic/company_model';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import log from '../../../services/logger_service';

export default function fetchCompanyDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(companyActions.companyLoading({}, store));
    return CompanyModel.fetch(params, store)
      .then(function handleCompanyDetailData(CompanyData) {
        dispatch(companyActions.companyLoaded(CompanyData.data, store));
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status.code') || 500;

        if (status === 404 || status === 401) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        }

        if (status === 500) {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(err, `Error in company actions, message: ${err.message}`);
        }

        dispatch(companyActions.companyLoadError(err, store));
      });
  };
}
